import { canRead, canWrite } from '../access/rbacAccess'

export const POC = {
  STORE_RELATIONS: 'planifica.poc_store_relations',
  ORDERS: 'ejecuta.poc_orders',
  FILL_RATE: 'mide.poc_fill_rate'
}

export const canViewPocStoreRelations = () => canRead(POC.STORE_RELATIONS)

export const canManagePocStoreRelations = () => canWrite(POC.STORE_RELATIONS)

export const canViewPocOrders = () => canRead(POC.ORDERS)

export const canManagePocOrders = () => canWrite(POC.ORDERS)

export const canViewPocFillRate = () => canRead(POC.FILL_RATE)
